import axiosInstance from '../api/axios';

export type InviteTargetRole = 'TRADER' | 'MERCHANT';

export interface InviteToken {
  id: string;
  token: string;
  target_role: InviteTargetRole;
  currency_id: string | null;
  currency_code: string | null;
  trader_group_id: string | null;
  trader_group_name: string | null;
  used: boolean;
  is_active: boolean;
  invited_user_id: string | null;
  invited_trader_id: string | null;
  invited_merchant_id: string | null;
  invited_username: string | null;
  invited_entity_name: string | null;
  expires_at: string | null;
  created_at: string;
  used_at: string | null;
}

export const inviteTokensService = {
  remove: async (id: string) => axiosInstance.delete(`/invite-tokens/${id}`),
  list: async (): Promise<InviteToken[]> =>
    (await axiosInstance.get('/invite-tokens/')).data,
  create: async (data: {
    target_role: InviteTargetRole;
    currency_id?: string;
    trader_group_id?: string;
    expires_at?: string;
  }) =>
    (await axiosInstance.post('/invite-tokens/', data)).data as InviteToken,
  deactivate: async (id: string) =>
    (await axiosInstance.patch(`/invite-tokens/${id}/deactivate`)).data as InviteToken,
};
